export default __webpack_public_path__ + "vladt@2x.3119c561.jpg";